import { ModelMail, OfficeModels } from "@/type/core/models/models.types";
import configuration from "@/utils/Config";
import {
  restCreationHandler,
  restDeletionHandler,
  restDetailsHandler,
  restPostHandler,
  restUpdateHandler,
} from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { DuplicateModelMailRequestDto } from "@state/modelMail/request/duplicate.model.mail.request.dto";
import { ModelMailOfficeRequestDto } from "@state/modelMail/request/model.mail.office.request.dto";
import { SearchModelMailRequestDto } from "@state/modelMail/request/search.model.mail.request.dto";
import { DefaultModelMailsResponseDto } from "@state/modelMail/response/default.model.mails.response.dto";
import { SearchModelMailResponseDto } from "@state/modelMail/response/search.model.mail.response.dto";

const baseUrl = configuration.backendBaseUrl;
const modelMailUrl = baseUrl + "/ws/fo/model-mail";
const defaultUrl = modelMailUrl + "/default";
const signatureUrl = "/signature";
const scellementUrl = "/scellement";
const searchModelMailUrl = modelMailUrl + "/search";
const officeUrl = modelMailUrl + "/office";

export const requestGetModelMailDefaultSignature = createEffect({
  handler: restDetailsHandler<DefaultModelMailsResponseDto>(
    defaultUrl,
    signatureUrl,
  ),
});

export const requestGetModelMailDefaultScellement = createEffect({
  handler: restDetailsHandler<DefaultModelMailsResponseDto>(
    defaultUrl,
    scellementUrl,
  ),
});

export const requestSearchModelMail = createEffect({
  handler: restPostHandler<
    SearchModelMailRequestDto,
    SearchModelMailResponseDto
  >(searchModelMailUrl),
});

export const requestUpdateModelMailDefault = createEffect({
  handler: restUpdateHandler<void, void>(modelMailUrl, "/default"),
});

export const requestCreateDuplicateModelMail = createEffect({
  handler: restPostHandler<DuplicateModelMailRequestDto, void>(
    modelMailUrl,
    "/duplicate",
  ),
});

export const requestDeleteModelMail = createEffect({
  handler: restDeletionHandler<void>(modelMailUrl),
});

export const requestGetModelMail = createEffect({
  handler: restDetailsHandler<ModelMail>(modelMailUrl),
});

export const requestCreateModelMail = createEffect({
  handler: restCreationHandler<ModelMail, ModelMail>(modelMailUrl),
});

export const requestUpdateModelMail = createEffect({
  handler: restUpdateHandler<ModelMail, ModelMail>(modelMailUrl),
});

export const requestGetModelMailForOffice = createEffect({
  handler: restDetailsHandler<OfficeModels[], ModelMailOfficeRequestDto>(
    officeUrl,
  ),
});

export const requestGetModelMailFromId = createEffect({
  handler: restDetailsHandler<ModelMail>(modelMailUrl),
});
